<template>
  <div class="page trips">
    <h1>Ritten</h1>
  </div>
</template>

<script>
export default {
  name: "Trips"
}
</script>
